import { EventEmitter } from 'events';
import _ from 'lodash';

import AppDispatcher from '../../../dispatcher/AppDispatcher';
import CashWalletConstants from './CashWalletConstants';

const HTTP_NOT_FOUND = 404;

const { FIRST_PAGE } = CashWalletConstants;

let _dashboard = null;
let _dashboard_status = CashWalletConstants.STATUS.INITIAL;

let _requests = [];
let _requests_page = FIRST_PAGE;
let _requests_count = 0;
let _requests_status = CashWalletConstants.STATUS.INITIAL;

let _detail = null;
let _detail_status = CashWalletConstants.STATUS.INITIAL;

let _cancel_status = CashWalletConstants.STATUS.INITIAL;
let _cancel_error = null;

let _submit_status = CashWalletConstants.STATUS.INITIAL;
let _submit_error = null;
let _submitted_request = null;

const CashWalletStore = _.extend({}, EventEmitter.prototype, {
    getDashboard: function () {
        return _dashboard;
    },

    getDashboardStatus: function () {
        return _dashboard_status;
    },

    getRequests: function () {
        return _requests;
    },

    getRequestsPage: function () {
        return _requests_page;
    },

    getRequestsCount: function () {
        return _requests_count;
    },

    getRequestsStatus: function () {
        return _requests_status;
    },

    getActiveRequest: function () {
        if (_requests_page !== FIRST_PAGE) {
            return null;
        }

        const submitted = _.filter(_requests, {
            status: CashWalletConstants.REQUEST_STATUS.SUBMITTED,
        });

        if (!submitted.length) {
            return null;
        }

        return _.maxBy(submitted, (request) => new Date(request.submitted_at).getTime());
    },

    getDetail: function () {
        return _detail;
    },

    getDetailStatus: function () {
        return _detail_status;
    },

    getCancelStatus: function () {
        return _cancel_status;
    },

    getCancelError: function () {
        return _cancel_error;
    },

    getSubmitStatus: function () {
        return _submit_status;
    },

    getSubmitError: function () {
        return _submit_error;
    },

    getSubmittedRequest: function () {
        return _submitted_request;
    },

    emitChange: function () {
        this.emit('change');
    },

    addChangeListener: function (callback) {
        this.on('change', callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener('change', callback);
    },
});

AppDispatcher.register(function (payload) {
    const action = payload.action;

    switch (action.actionType) {
        case CashWalletConstants.RETRIEVE_DASHBOARD:
            _dashboard_status = CashWalletConstants.STATUS.BUSY;
            break;

        case CashWalletConstants.DASHBOARD_SUCCEEDED:
            _dashboard = action.data.response;
            _dashboard_status = CashWalletConstants.STATUS.SUCCESS;
            break;

        case CashWalletConstants.DASHBOARD_FAILED:
            if (action.data.error?.status === HTTP_NOT_FOUND) {
                _dashboard = { available: false };
                _dashboard_status = CashWalletConstants.STATUS.SUCCESS;
            } else {
                _dashboard = null;
                _dashboard_status = CashWalletConstants.STATUS.ERROR;
            }
            break;

        case CashWalletConstants.RETRIEVE_REQUESTS:
            _requests_status = CashWalletConstants.STATUS.BUSY;
            break;

        case CashWalletConstants.REQUESTS_SUCCEEDED: {
            const response = action.data.response || {};
            _requests = response.requests || [];
            _requests_page = response.page || FIRST_PAGE;
            _requests_count = response.count || 0;
            _requests_status = CashWalletConstants.STATUS.SUCCESS;
            break;
        }

        case CashWalletConstants.REQUESTS_FAILED:
            _requests = [];
            _requests_count = 0;
            _requests_status = CashWalletConstants.STATUS.ERROR;
            break;

        case CashWalletConstants.RETRIEVE_REQUEST_DETAIL:
            _detail = null;
            _detail_status = CashWalletConstants.STATUS.BUSY;
            _cancel_status = CashWalletConstants.STATUS.INITIAL;
            _cancel_error = null;
            break;

        case CashWalletConstants.REQUEST_DETAIL_SUCCEEDED:
            _detail = action.data.response?.request || null;
            _detail_status = CashWalletConstants.STATUS.SUCCESS;
            break;

        case CashWalletConstants.REQUEST_DETAIL_FAILED:
            _detail = null;
            _detail_status = CashWalletConstants.STATUS.ERROR;
            break;

        case CashWalletConstants.CANCEL_REQUEST:
            _cancel_status = CashWalletConstants.STATUS.BUSY;
            _cancel_error = null;
            break;

        case CashWalletConstants.CANCEL_SUCCEEDED:
            _cancel_status = CashWalletConstants.STATUS.SUCCESS;
            _cancel_error = null;
            break;

        case CashWalletConstants.CANCEL_FAILED:
            _cancel_status = CashWalletConstants.STATUS.ERROR;
            _cancel_error = action.data.code || null;
            break;

        case CashWalletConstants.RESET_SUBMIT:
            _submit_status = CashWalletConstants.STATUS.INITIAL;
            _submit_error = null;
            _submitted_request = null;
            break;

        case CashWalletConstants.SUBMIT_REQUEST:
            _submit_status = CashWalletConstants.STATUS.BUSY;
            _submit_error = null;
            break;

        case CashWalletConstants.SUBMIT_SUCCEEDED:
            _submit_status = CashWalletConstants.STATUS.SUCCESS;
            _submit_error = null;
            _submitted_request = action.data.response?.request || null;
            break;

        case CashWalletConstants.SUBMIT_FAILED:
            _submit_status = CashWalletConstants.STATUS.ERROR;
            _submit_error = action.data.code || null;
            break;

        default:
            return true;
    }

    CashWalletStore.emitChange();

    return true;
});

export default CashWalletStore;
